<template>
  <div id="app">
    <div v-if="isLoaded">
      <div class="container">
        <div>
          <div v-show="showProductFlag">
            <div>
              <a href="/" @click.prevent="showProductFlag = false"
                ><i class="fas fa-home"></i> <span>Terug naar aanbiedingen</span></a
              >
            </div>
            <div class="mt-3" v-if="showProductFlag">
              <div class="product-preview">
                <div class="row mb-4">
                  <div class="col-md-7 mb-4">
                    <div class="product-zoom-preview">
                    <image-zoom  hover-message="Beweeg om in te zoomen"
                      :regular="productForPreview.images[0]
                          ? secureImage(productForPreview.images[0].url_large)
                          : defaultImage" 
                      :zoom="productForPreview.images[0]
                          ? secureImage(productForPreview.images[0].url_large)
                          : defaultImage" zoom-amount="2">				
                    </image-zoom>
                    </div>

                    <!-- <img
                      class="w-100"
                      :src="
                        productForPreview.images[0]
                          ? secureImage(productForPreview.images[0].url_large)
                          : defaultImage
                      "
                    /> -->
                  </div>
                  <div class="col-md-5">
                    <h2>{{ productForPreview.supplier_data[0][8] }}</h2>
                    <p>{{ productForPreview.product_group_sub }}</p>
                    <p>{{ productForPreview.product_group_sub_sub }}</p>
                    <p>
                      {{
                        `€ ${numberWithCommas(productForPreview.salesprice)}`
                      }}
                    </p>
                    <div class="product-card__btns">
                      <a href="tel:0475642434" class="mr-2"
                        ><i class="fas fa-phone"
                      /></a>
                      <a href="mailto:info@jabobikes.be" class="mr-2"
                        ><i class="fas fa-envelope"
                      /></a>
                      <a href="https://g.page/jabobikes?share" target="_blank"
                        >Bezoek onze winkel</a
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <h3>Specifications</h3>
                  </div>
                  <div class="col-md-6">
                    <table class="table">
                      <tr v-if="productForPreview.product_group_sub">
                        <td><span>Type fiets:</span></td>
                        <td>
                          <span>{{ productForPreview.product_group_sub }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td><span>Merk:</span></td>
                        <td>
                          <span>{{
                            productForPreview.supplier_data[0][5]
                          }}</span>
                        </td>
                      </tr>
                      <tr v-if="productForPreview.supplier_data[0][6]">
                        <td><span>Model:</span></td>
                        <td>
                          <span>{{
                            productForPreview.supplier_data[0][6]
                          }}</span>
                        </td>
                      </tr>
                      <tr v-if="productForPreview.supplier_data[0][13]">
                        <td><span>Modeljaar:</span></td>
                        <td>
                          <span>{{
                            productForPreview.supplier_data[0][13]
                          }}</span>
                        </td>
                      </tr>
                      <tr v-if="productForPreview.supplier_data[0][7]">
                        <td><span>Primaire basiskleur</span></td>
                        <td>
                          <span>{{
                            productForPreview.supplier_data[0][7]
                          }}</span>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-md-6">
                    <table class="table">
                      <tr v-if="productForPreview.supplier_data[0][9]">
                        <td><span>Maat:</span></td>
                        <td>
                          <span>{{
                            productForPreview.supplier_data[0][9]
                          }}</span>
                        </td>
                      </tr>
                      <tr v-if="productForPreview.supplier_data[0][30]">
                        <td><span>Weight gewicht:</span></td>
                        <td>
                          <span>{{
                            productForPreview.supplier_data[0][30]
                          }}</span>
                        </td>
                      </tr>
                      <tr v-if="productForPreview.supplier_data[0][31]">
                        <td><span>Netto gewicht:</span></td>
                        <td>
                          <span>{{
                            productForPreview.supplier_data[0][31]
                          }}</span>
                        </td>
                      </tr>
                      <tr v-if="productForPreview.supplier_data[0][33]">
                        <td><span>Wielmaat:</span></td>
                        <td>
                          <span>{{
                            productForPreview.supplier_data[0][33]
                          }}</span>
                        </td>
                      </tr>
                      <tr v-if="productForPreview.supplier_data[0][34]">
                        <td><span>Frametype:</span></td>
                        <td>
                          <span>{{
                            productForPreview.supplier_data[0][34]
                          }}</span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="!showProductFlag">
            <div class="row">
              <div class="col-lg-2 col-md-3">
                <div class="fietsen-filter">
                  <!-- <h5>Filter Products</h5>
                <hr /> -->
                  <div class="mb-3">
                    <SfSearchBar
                      placeholder="Zoeken"
                      :icon="{ size: '1.25rem' }"
                      aria-label="Zoeken"
                      v-model="searchVal"
                      @input="search"
                    />
                    <div class="mb-4">
                      <p v-if="currentMinMax[0] || currentMinMax[1]">
                        <small class="product-card__price d-block mt-4"
                          >Prijsbereik:</small
                        >
                        <small>
                          €{{ numberWithCommas(currentMinMax[0]) }} - €{{
                            numberWithCommas(currentMinMax[1])
                          }}
                        </small>
                      </p>
                    </div>
                    <div v-if="!currentMinMax[1]" class="mb-3">
                      <small>Filteren op prijs: </small>
                    </div>
                    <PriceRangeSlider
                      :trackHeight="0.5"
                      @filterPrice="filterPrice"
                      :minValue="minMax[0]"
                      :maxValue="minMax[1]"
                    />
                  </div>

                  <SfAccordion
                    transition="sf-expand"
                    open="Categorie"
                    showChevron
                  >
                    <SfAccordionItem header="Categorie">
                      <SfList>
                        <SfListItem
                          ><SfMenuItem
                            label="All"
                            :count="filterTotal.category"
                            @click="filterProduct('all')"
                          ></SfMenuItem
                        ></SfListItem>
                        <SfListItem
                          v-for="(brand, propertyName) in filter.category"
                          :key="propertyName"
                          ><SfMenuItem
                            @click="filterProduct(propertyName, 'category')"
                            :label="propertyName"
                            :count="brand"
                        /></SfListItem>
                      </SfList>
                    </SfAccordionItem>
                    <SfAccordionItem header="Merken">
                      <SfList>
                        <SfListItem
                          ><SfMenuItem
                            label="All"
                            :count="filterTotal.fietsen"
                            @click="filterProduct('all')"
                          ></SfMenuItem
                        ></SfListItem>
                        <SfListItem
                          v-for="(brand, propertyName) in filter.fietsen"
                          :key="propertyName"
                          ><SfMenuItem
                            @click="filterProduct(propertyName, 'brand')"
                            :label="propertyName"
                            :count="brand"
                        /></SfListItem>
                      </SfList>
                    </SfAccordionItem>
                  </SfAccordion>

                   <SfAccordion
                    transition="sf-expand"
                    open="Subcategorie"
                    showChevron
                  >

                  <SfAccordionItem header="Subcategorie" v-if="filter.subCateg[currentFilter]">
                      <SfList>
                        <SfListItem
                          v-for="(brand, propertyName) in filter.subCateg[currentFilter]"
                          :key="propertyName"
                          ><SfMenuItem
                            @click="filterProduct(propertyName, 'subcateg')"
                            :label="propertyName.split(' ')[0]"
                            :count="brand"
                        /></SfListItem>
                      </SfList>
                    </SfAccordionItem>
                                    </SfAccordion>
                </div>
              </div>
              <div class="col-lg-10 col-md-9">
                <div v-for="(item, key) in productsObj" :key="key">
                  <h3
                    class="product-card__header"
                    v-if="productsObj[key].length > 0"
                  >
                    {{ key }}
                  </h3>
                  <div
                    class="product-card-container"
                    v-if="productsObj[key].length > 0"
                  >
                    <div
                      v-for="(item,index) in productsObj[key]"
                      :key="index"
                      class="product-card__item"
                    >
                      <img
                        class="product-card__img"
                        :src="
                          item.images[0]
                            ? secureImage(item.images[0].url_thumb)
                            : defaultImage
                        "
                      />
                      <div class="product-card__details">
                        <div class="mb-3">
                          <h5 class="product-card__name">
                            {{ item.supplier_data[0][8] }}
                          </h5>
                          <span class="product-card__price d-block mb-1 pb-0">{{
                            item.supplier_data[0][1]
                          }}</span>
                          <span class="product-card__price d-block mb-1 pb-0">{{
                            item.product_group_sub
                          }}</span>
                          <span class="product-card__price">{{
                            `€ ${numberWithCommas(item.salesprice)}`
                          }}</span>
                        </div>
                        <div class="product-card__btns">
                          <a
                            href="#"
                            class="w-100"
                            @click.prevent="showProduct(item)"
                            >Details</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-show="products.length == 0">
                  <div class="text-center p-4">
                    <h4>Not found</h4>
                    <p>
                      Filter applied doesn't match any of the existing product.
                    </p>
                  </div>
                </div>
                <!-- <div class="mt-4">
                <SfCallToAction
                  title="Subscribe to Newsletters"
                  buttonText="Subscribe"
                  description="Be aware of upcoming sales and events. Receive gifts and special offers!"
                  background="#e1e3e2"
                  image="https://uptodatewebdesign.s3.eu-west-3.amazonaws.com/uploads/photos-1620742343252.jpeg"
                />
              </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      <div class="post-loader">
        <div class="loader"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "@storefront-ui/vue/styles.scss";
import PriceRangeSlider from "./components/RangeSlider.vue";
import axios from "axios";
import imageZoom from 'vue-image-zoomer';
import {
  //SfBanner,
  // SfCallToAction,
  // SfHeader,
  //SfHero,
  // SfProductCard,
  SfSearchBar,
  SfAccordion,
  SfList,
  SfMenuItem,
  // SfButton,
  // SfProductCardHorizontal,
  // SfTabs,
  // SfTable,
} from "@storefront-ui/vue";

export default {
  name: "App",
  components: {
    //SfBanner,
    // SfCallToAction,
    //SfHero,
    // SfProductCard,
    SfSearchBar,
    SfAccordion,
    SfList,
    SfMenuItem,
    PriceRangeSlider,
      imageZoom
    // SfButton,
    // SfProductCardHorizontal,
    // SfTabs,
    // SfTable,
  },
  data() {
    return {
      products: [],
      productTemp: [],
      isLoaded: false,
      searchVal: "",
      showProductFlag: false,
      productForPreview: null,
      filterTotal: {
        fietsen: 0,
        accessories: 0,
      },
      defaultImage:
        "https://lh3.googleusercontent.com/-0hrbkGR-Jhs/YEoU2_45H_I/AAAAAAAAk0w/ebvfy014zmM9BB0N-qwrzMe6EXA_2eemgCLcBGAsYHQ/s1600/shutterstock_134107355.jpg",
      filter: {
        fietsen: {},
        category: {},
        accessories: {},
        subCateg: {

        }
      },
      filters: [],
      minMax: [],
      productsObj: {},
      currentMinMax: [],
      currentFilter: ''
    };
  },
  created() {
    this.getPosts();
  },
  methods: {
    init() {},
    secureImage(image) {
      return image.replace("http://", "https://") || this.defaultImage;
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async showProduct(product) {
      this.showProductFlag = true;
      this.productForPreview = product;
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    search(item) {
      let obj = {};
      if (item) {
        item = item.toLowerCase().replace(/ /g, "");
      }
      for (let key in this.productTemp) {
        obj[key] = this.productTemp[key].filter((productItem) => {
          if (productItem.searchText.indexOf(item) >= 0) {
            return productItem;
          }
        });
      }
      this.productsObj = obj;
    },
    filterPrice(val) {
      this.currentMinMax = [val.min, val.max];
      let obj = {};
      for (let key in this.productTemp) {
        obj[key] = this.productTemp[key].filter((productItem) => {
          let price = parseInt(productItem.salesprice);
          if (price > val.min && price < val.max) {
            return productItem;
          }
        });
      }
      this.productsObj = obj;
    },
    filterProduct(keyword, type) {

      let filter = {
        brand: "brand",
        category: "product_group_sub",
      };
      if (type == 'category') {
        this.currentFilter = keyword
      }
      if (keyword === "all") {
        this.productsObj = this.productTemp;
      }else if (type === 'subcateg') {
        let obj = {};
        obj[this.currentFilter] = this.productTemp[this.currentFilter].filter(productItem => {
          if (productItem.product_group_sub_sub === keyword) {
            return productItem
          }
        })
        this.productsObj = obj;
      } else {
        type = filter[type];
        let obj = {};
        for (let key in this.productTemp) {
          obj[key] = this.productTemp[key].filter((productItem) => {
            if (productItem[type] === keyword) {
              return productItem;
            }
          });
        }
        this.productsObj = obj;
      }
    },
    async apiCall(url) {
      return await axios.post(
        `https://www.uptodateconnect.com/api/v1/blogger/proxy`,
        {
          url: url,
          auth: {
            username: "ef7d3fd13558696fa66c96636c561820",
            password: "9616bc40f3e1c7f256a11a2b87d6c622",
          },
        }
      );
    },
    async getPosts() {
      let results = await this.apiCall(
        `https://api.cyclesoftware.nl/app/api/v3/articledata/`
      );
      if (results.data.data) {
        let min = 0;
        let max = 0;
        let productsObj = {};
        this.products = results.data.data.filter((post) => {
          if (post.supplier_data[0] && post.has_stock) {
            let price = parseInt(post.salesprice);
            if (price <= min) {
              min = price;
            }
            if (price >= max) {
              max = price;
            }
            if (!productsObj[post.product_group_sub]) {
              productsObj[post.product_group_sub] = [];
            }
            if (post.is_bicycle) {
              if (!this.filter.fietsen[post.brand]) {
                this.filter.fietsen[post.brand] = 0;
              }
              if (!this.filter.category[post.product_group_sub]) {
                this.filter.category[post.product_group_sub] = 0;
                this.filter.subCateg[post.product_group_sub] = {}
              }
              
              if (post.product_group_sub_sub) {
                  // let name = post.product_group_sub_sub.split(' ')[0]
                  if (!this.filter.subCateg[post.product_group_sub][post.product_group_sub_sub]) {
 
                    this.filter.subCateg[post.product_group_sub][post.product_group_sub_sub] = 0
                  }
                  this.filter.subCateg[post.product_group_sub][post.product_group_sub_sub] += 1;
              }
              
              this.filter.fietsen[post.brand] += 1;
              this.filter.category[post.product_group_sub] += 1;
              this.filterTotal.fietsen += 1;
            } else {
              if (!this.filter.accessories[post.brand]) {
                this.filter.accessories[post.brand] = 0;
              }
              this.filter.accessories[post.brand] += 1;
              this.filterTotal.accessories += 1;
            }
            post.product_name = post.supplier_data[0][8];
            let searchText = post.supplier_data[0][8]
              .toLowerCase()
              .replace(/ /g, "");
              searchText += post.product_group_sub.toLowerCase().replace(/ /g, "");
              searchText += post.brand.toLowerCase().replace(/ /g, "");

            post.searchText = searchText
            productsObj[post.product_group_sub].push(post);
            return post;
          }
        });
        this.productsObj = productsObj;

        this.productTemp = this.productsObj;
        this.isLoaded = true;
        this.minMax = [min, max];
      }
    },
  },
};
</script>

<style>

.sf-search-bar {
  --search-bar-width: unset;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 30px;
}

@media screen and (max-width: 768px){
  #app {
    margin-top: 0;
  }
}

.sf-banner__wrapper {
  position: relative;
  z-index: 9;
}
.sf-banner__subtitle,
.sf-banner__title,
.sf-banner__description {
  color: white;
}
.with-overlay-5:after,
.with-overlay-theme:after,
.with-overlay:after {
  background: #00000061;
}
.sf-category-card {
  background-size: cover;
}
.fietsen-filter {
  position: sticky;
  top: 80px;
}
.sf-button {
  text-decoration: unset;
}
.product-card-container {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-around; */
}
.product-card__item {
  width: 22%;
  border: 1px solid #efeeeeeb;
  background: white;
  box-shadow: 1px 6px 10px rgb(0 0 0 / 6%);
  margin: 10px;
  line-height: 16px;
  display: flex;
  flex-direction: column;
}

.product-card__details {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 15px;
  text-align: center;
}
.product-card__price {
  font-weight: bold;
}
.product-card__name {
  font-size: 16px;
  margin-bottom: 10px;
}
.product-card__img {
  width: 100%;
  object-fit: contain;
  padding: 10px;
}
.product-card__btns {
  display: flex;
}
.product-card__btns a {
  /* width: 100%; */
  display: inline-block;
  margin: 0;
  padding: 10px;
  /* width: 100%; */
  font-weight: 500;
  font-size: 14px;
  /* padding: 13px 0; */
  /* float: left; */
  text-align: center;
  background-color: var(--theme);
  color: #fff;
  padding: 5px 15px;
  text-transform: uppercase;
}
.product-card__btns a.w-100 {
  padding: 10px;
}
.product-card__header {
  font-size: 28px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.product-zoom-preview {
  width: 100%;
  overflow: hidden;
}

.vh--outer.vh--rel {
  width: 100%;
}
.product-preview img {
  width: 100%;
}
@media screen and (max-width: 1300px) {
  .product-card__item {
    width: 30%;
  }
}
@media screen and (max-width: 1100px) {
  .product-card__item {
    width: 45%;
  }
}

@media screen and (max-width: 768px) {
  .product-card__item {
    width: 100%;
  }

  .product-card__btns {
    flex-direction: column;
  }
  .product-card__btns a {
    margin-bottom: 10px;
  }
}
.sf-search-bar__input[type="search"] {
  padding-left: 0;
  font-size: 18px !important;
}
.sf-button, .product-card__price {
font-size: 16px;
}
.sf-menu-item__label {
  text-align: left;
}
</style>
